import { createStore, createEffect, createEvent, combine } from 'effector';
import { ApiUtilsV2 } from '@shared/utils';
import {
  DashboardApi,
  RequestStrategyEnum,
  type ApiResponse,
  type PaymentSummariesRequest,
  type PaymentSummariesResponse,
  type WithSignal,
} from '@shared/api';

const getPaymentSummaryEffect = createEffect(({ signal, ...request }: WithSignal<PaymentSummariesRequest>) =>
  DashboardApi.getPaymentSummary(request, signal),
);
const clearEvent = createEvent();

const $dataStore = createStore<PaymentSummariesResponse | {}>({})
  .on(getPaymentSummaryEffect.done, (current, data) => data.result.data ?? current)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(getPaymentSummaryEffect.pending, (_, data) => data)
  .on(getPaymentSummaryEffect.fail, (_, data) => ApiUtilsV2.abortApiLoadingFailCaseTrigger(data.error))
  .on(getPaymentSummaryEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getPaymentSummaryEffect, () => null)
  // .on(getPaymentSummaryEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(getPaymentSummaryEffect.fail, () => 'Something went wrong while fetching Yearly Transaction Summary. Please try again.')
  .on(getPaymentSummaryEffect.done, () => null)
  .reset(clearEvent);

const getPaymentSummaryApi = ApiUtilsV2.wrapperApi<PaymentSummariesRequest, ApiResponse<PaymentSummariesResponse>>(
  getPaymentSummaryEffect,
  RequestStrategyEnum.Abort,
);
clearEvent.watch(() => getPaymentSummaryApi.cancel());

export const $yearlyTransactionStore = {
  events: {
    update: getPaymentSummaryApi.trigger,
    clear: clearEvent,
  },
  store: combine({
    data: $dataStore,
    loading: $loadingStore,
    error: $errorStore,
  }),
};
